// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"39233a63","453":"0fd077a5","576":"6d1fb7d8","759":"9881ce62","780":"891284ec","952":"5b95ef8e"}[chunkId] + ".chunk.js";
};